import React, { useEffect, useState } from 'react';
import { getAuthHeader, getUserInfo } from '../utils/tokenManager';

const PartnerManagement = () => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [isEditOpen, setIsEditOpen] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [bankOptions, setBankOptions] = useState([]);
  const [isCreateOpen, setIsCreateOpen] = useState(false);
  const [filterName, setFilterName] = useState('');
  const [filterEmail, setFilterEmail] = useState('');
  const [filterUse, setFilterUse] = useState('all');
  const [form, setForm] = useState({
    거래처명: '',
    대표이메일: '',
    대표자: '',
    담당자: '',
    국가번호: '',
    대표전화: '',
    기본주소: '',
    우편번호: '',
    상세주소: '',
    은행: '',
    은행코드: '',
    계좌번호: '',
    예금주: '',
    사용여부: true,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError('');
        const { companyNo } = getUserInfo() || {};
        const payload = {
          Table1: [
            { 컬럼명: '@업체번호', 값: String(companyNo) },
            { 컬럼명: '@사용여부1', 값: true },
            { 컬럼명: '@사용여부2', 값: true },
          ],
        };
        const url = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.CW_S_%EA%B3%B5%EA%B8%89%EA%B1%B0%EB%9E%98%EC%B2%98';
        const res = await fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error('Failed to load');
        const data = await res.json();
        setRows(Array.isArray(data?.table) ? data.table : []);
      } catch (e) {
        setError('데이터를 불러오지 못했습니다.');
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const openEdit = async (row) => {
    setEditRow(row);
    setForm({
      거래처명: row?.거래처명 ?? '',
      대표이메일: row?.대표이메일 ?? '',
      대표자: row?.대표자명 ?? '',
      담당자: row?.담당자명 ?? '',
      국가번호: row?.국가번호 ?? '',
      대표전화: row?.대표전화 ?? '',
      기본주소: row?.기본주소 ?? '',
      우편번호: row?.우편번호 ?? '',
      상세주소: row?.상세주소 ?? '',
      은행: row?.은행명 ?? '',
      은행코드: row?.은행코드 ?? '',
      계좌번호: row?.계좌번호 ?? '',
      예금주: row?.예금주 ?? '',
      사용여부: !!row?.사용여부,
    });
    try {
      const { companyNo } = getUserInfo() || {};
      const payload = {
        Table1: [
          { 컬럼명: '@종류', 값: 'CW수납은행', 리스트값: null },
          { 컬럼명: '@공급업체번호', 값: String(companyNo ?? '1'), 리스트값: null },
        ],
      };
      const url = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.RCT_S_%EC%88%98%EB%8F%99%EC%BD%94%EB%93%9C';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        const data = await res.json();
        const list = Array.isArray(data?.table) ? data.table : [];
        setBankOptions(list.map(x => ({ code: x?.코드 ?? '', name: x?.코드명 ?? '' })));
      } else {
        setBankOptions([]);
      }
    } catch (e) {
      setBankOptions([]);
    }
    setIsEditOpen(true);
  };

  const closeEdit = () => {
    setIsEditOpen(false);
    setEditRow(null);
  };

  const openCreate = async () => {
    setForm({
      거래처명: '',
      대표이메일: '',
      대표자: '',
      담당자: '',
      국가번호: '',
      대표전화: '',
      기본주소: '',
      우편번호: '',
      상세주소: '',
      은행: '',
      은행코드: '',
      계좌번호: '',
      예금주: '',
      사용여부: true,
    });
    try {
      const { companyNo } = getUserInfo() || {};
      const payload = {
        Table1: [
          { 컬럼명: '@종류', 값: 'CW수납은행', 리스트값: null },
          { 컬럼명: '@공급업체번호', 값: String(companyNo ?? '1'), 리스트값: null },
        ],
      };
      const url = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.RCT_S_%EC%88%98%EB%8F%99%EC%BD%94%EB%93%9C';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
        body: JSON.stringify(payload),
      });
      if (res.ok) {
        const data = await res.json();
        const list = Array.isArray(data?.table) ? data.table : [];
        setBankOptions(list.map(x => ({ code: x?.코드 ?? '', name: x?.코드명 ?? '' })));
      } else {
        setBankOptions([]);
      }
    } catch (e) {
      setBankOptions([]);
    }
    setIsCreateOpen(true);
  };

  const closeCreate = () => {
    setIsCreateOpen(false);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  const handleBankChange = (e) => {
    const name = e.target.value;
    const found = bankOptions.find(b => b.name === name);
    setForm((prev) => ({
      ...prev,
      은행: name,
      은행코드: found?.code || '',
    }));
  };

  const handleSave = async () => {
    try {
      if (!editRow) return;
      const { companyNo, userNo } = getUserInfo() || {};
      const payload = {
        Table1: [
          { 컬럼명: '@공급업체번호', 값: String(companyNo ?? '') },
          { 컬럼명: '@등록자', 값: String(userNo ?? '') },
          { 컬럼명: '@거래처번호', 값: Number(editRow?.거래처번호) },
          { 컬럼명: '@신규업체명', 값: form.거래처명 ?? '' },
          { 컬럼명: '@이메일', 값: form.대표이메일 ?? '' },
          { 컬럼명: '@대표자', 값: form.대표자 ?? '' },
          { 컬럼명: '@담당자', 값: form.담당자 ?? '' },
          { 컬럼명: '@기본주소', 값: form.기본주소 ?? '' },
          { 컬럼명: '@상세주소', 값: form.상세주소 ?? '' },
          { 컬럼명: '@우편번호', 값: form.우편번호 ?? '' },
          { 컬럼명: '@국가번호', 값: form.국가번호 ?? '' },
          { 컬럼명: '@대표전화', 값: form.대표전화 ?? '' },
          { 컬럼명: '@사용여부', 값: !!form.사용여부 },
          { 컬럼명: '@은행코드', 값: form.은행코드 ?? '' },
          { 컬럼명: '@계좌번호', 값: form.계좌번호 ?? '' },
          { 컬럼명: '@예금주', 값: form.예금주 ?? '' },
          { 컬럼명: '@은행명', 값: form.은행 ?? '' },
        ],
      };
      const url = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.CW_S_%EA%B3%B5%EA%B8%89%EA%B1%B0%EB%9E%98%EC%B2%98%EC%A0%95%EB%B3%B4%EC%88%98%EC%A0%95';
      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
        body: JSON.stringify(payload),
      });
      if (!res.ok) {
        window.alert('저장에 실패했습니다.');
        return;
      }
      const saveData = await res.json();
      const saved = Array.isArray(saveData?.table) && saveData.table.length > 0;
      if (saved) {
        const statusText = saveData.table[0]?.상태;
        window.alert(statusText ? `저장되었습니다. (${statusText})` : '저장되었습니다.');
      } else {
        window.alert('저장에 실패했습니다.');
      }
      // Refresh list
      const reloadUrl = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.CW_S_%EA%B3%B5%EA%B8%89%EA%B1%B0%EB%9E%98%EC%B2%98';
      const reloadPayload = {
        Table1: [
          { 컬럼명: '@업체번호', 값: String(companyNo ?? '') },
          { 컬럼명: '@사용여부1', 값: true },
          { 컬럼명: '@사용여부2', 값: true },
        ],
      };
      const r2 = await fetch(reloadUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
        body: JSON.stringify(reloadPayload),
      });
      if (r2.ok) {
        const data = await r2.json();
        setRows(Array.isArray(data?.table) ? data.table : []);
      }
      closeEdit();
    } catch (e) {
      window.alert('저장에 실패했습니다.');
    }
  };

  const filteredRows = React.useMemo(() => {
    return rows.filter(r => {
      const nameOk = filterName ? String(r?.거래처명 || '').toLowerCase().includes(filterName.toLowerCase()) : true;
      const emailOk = filterEmail ? String(r?.대표이메일 || '').toLowerCase().includes(filterEmail.toLowerCase()) : true;
      const useOk = filterUse === 'all' ? true : (filterUse === 'use' ? !!r?.사용여부 : !r?.사용여부);
      return nameOk && emailOk && useOk;
    });
  }, [rows, filterName, filterEmail, filterUse]);

  return (
    <div className="p-4">
      <div className="flex items-center justify-between mb-3">
        <h1 className="text-lg font-semibold">공급사 관리</h1>
        <button
          type="button"
          className="px-3 py-1.5 text-sm rounded bg-primary-600 text-white hover:bg-primary-700"
          onClick={openCreate}
        >
          신규 추가
        </button>
      </div>
      <div className="mb-3 grid grid-cols-1 md:grid-cols-4 gap-2">
        <input
          value={filterName}
          onChange={(e) => setFilterName(e.target.value)}
          className="w-full border rounded px-3 py-2 text-sm"
          placeholder="공급사명 검색"
        />
        <input
          value={filterEmail}
          onChange={(e) => setFilterEmail(e.target.value)}
          className="w-full border rounded px-3 py-2 text-sm"
          placeholder="대표이메일 검색"
        />
        <select
          value={filterUse}
          onChange={(e) => setFilterUse(e.target.value)}
          className="w-full border rounded px-3 py-2 text-sm"
        >
          <option value="all">사용여부(전체)</option>
          <option value="use">사용</option>
          <option value="not">미사용</option>
        </select>
        <div className="flex gap-2">
          <button
            type="button"
            className="px-3 py-2 text-sm rounded border border-gray-300 hover:bg-gray-50 w-full"
            onClick={() => { setFilterName(''); setFilterEmail(''); setFilterUse('all'); }}
          >
            초기화
          </button>
        </div>
      </div>
      {loading && (
        <div className="py-10 text-center text-gray-500">로딩 중...</div>
      )}
      {!loading && error && (
        <div className="py-10 text-center text-red-600">{error}</div>
      )}
      {!loading && !error && (
        <div className="overflow-auto border border-gray-200 rounded-md">
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">거래처명</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">대표자명</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">담당자명</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">대표이메일</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">대표전화</th>
                <th className="px-4 py-2 text-left text-sm font-medium text-gray-700">사용여부</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-100 bg-white">
              {filteredRows.map((r, idx) => (
                <tr key={idx} className="group hover:bg-gray-50">
                  <td className="px-4 py-2 text-sm text-gray-900 whitespace-nowrap">{r?.거래처명 ?? ''}</td>
                  <td className="px-4 py-2 text-sm text-gray-700 whitespace-nowrap">{r?.대표자명 ?? ''}</td>
                  <td className="px-4 py-2 text-sm text-gray-700 whitespace-nowrap">{r?.담당자명 ?? ''}</td>
                  <td className="px-4 py-2 text-sm text-gray-700 whitespace-nowrap">{r?.대표이메일 ?? ''}</td>
                  <td className="px-4 py-2 text-sm text-gray-700 whitespace-nowrap">{r?.대표전화 ?? ''}</td>
                  <td className="px-4 py-2 text-sm whitespace-nowrap relative">
                    <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium transition-opacity ${r?.사용여부 ? 'bg-green-50 text-green-700' : 'bg-gray-100 text-gray-600'} group-hover:opacity-0`}>
                      {r?.사용여부 ? '사용' : '미사용'}
                    </span>
                    <button
                      type="button"
                      className="absolute inset-0 m-auto h-8 w-16 px-0 py-0 text-sm rounded border border-gray-300 bg-white/90 hover:bg-gray-50 opacity-0 group-hover:opacity-100 transition-opacity"
                      onClick={() => openEdit(r)}
                      style={{ width: '56px', height: '28px' }}
                    >
                      편집
                    </button>
                  </td>
                </tr>
              ))}
              {filteredRows.length === 0 && (
                <tr>
                  <td colSpan={6} className="px-4 py-6 text-center text-sm text-gray-500">표시할 데이터가 없습니다.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {isEditOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/30" onClick={closeEdit} />
          <div className="relative bg-white rounded-lg shadow-lg w-full max-w-3xl mx-4">
            <div className="px-5 py-3 border-b">
              <div className="text-base font-semibold">거래처 편집</div>
            </div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm text-gray-600 mb-1">거래처명</label>
                <input name="거래처명" value={form.거래처명} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">대표 이메일</label>
                <input name="대표이메일" value={form.대표이메일} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">대표자</label>
                <input name="대표자" value={form.대표자} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">국가번호</label>
                <input name="국가번호" value={form.국가번호} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" placeholder="예: +82" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">대표전화</label>
                <input name="대표전화" value={form.대표전화} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">기본주소</label>
                <input name="기본주소" value={form.기본주소} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">우편번호</label>
                <input name="우편번호" value={form.우편번호} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">상세주소</label>
                <input name="상세주소" value={form.상세주소} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">은행</label>
                <select name="은행" value={form.은행} onChange={handleBankChange} className="w-full border rounded px-3 py-2 text-sm">
                  <option value="">선택</option>
                  {bankOptions.map((b) => (
                    <option key={`${b.code}-${b.name}`} value={b.name}>{b.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">계좌번호</label>
                <input name="계좌번호" value={form.계좌번호} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">예금주</label>
                <input name="예금주" value={form.예금주} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div className="flex items-center gap-2">
                <input id="useYn" type="checkbox" name="사용여부" checked={!!form.사용여부} onChange={handleChange} className="h-4 w-4" />
                <label htmlFor="useYn" className="text-sm text-gray-700">사용여부</label>
              </div>
            </div>
            <div className="px-5 py-3 border-t flex justify-end gap-2">
              <button type="button" className="px-4 py-2 text-sm rounded border border-gray-300 hover:bg-gray-50" onClick={closeEdit}>취소</button>
              <button type="button" className="px-4 py-2 text-sm rounded bg-primary-600 text-white hover:bg-primary-700" onClick={handleSave}>저장</button>
            </div>
          </div>
        </div>
      )}

      {isCreateOpen && (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
          <div className="absolute inset-0 bg-black/30" onClick={closeCreate} />
          <div className="relative bg-white rounded-lg shadow-lg w-full max-w-3xl mx-4">
            <div className="px-5 py-3 border-b">
              <div className="text-base font-semibold">거래처 추가</div>
            </div>
            <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm text-gray-600 mb-1">거래처명</label>
                <input name="거래처명" value={form.거래처명} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">대표 이메일</label>
                <input name="대표이메일" value={form.대표이메일} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">대표자</label>
                <input name="대표자" value={form.대표자} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">국가번호</label>
                <input name="국가번호" value={form.국가번호} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" placeholder="예: +82" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">대표전화</label>
                <input name="대표전화" value={form.대표전화} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">기본주소</label>
                <input name="기본주소" value={form.기본주소} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">우편번호</label>
                <input name="우편번호" value={form.우편번호} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">상세주소</label>
                <input name="상세주소" value={form.상세주소} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">은행</label>
                <select name="은행" value={form.은행} onChange={handleBankChange} className="w-full border rounded px-3 py-2 text-sm">
                  <option value="">선택</option>
                  {bankOptions.map((b) => (
                    <option key={`${b.code}-${b.name}`} value={b.name}>{b.name}</option>
                  ))}
                </select>
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">계좌번호</label>
                <input name="계좌번호" value={form.계좌번호} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div>
                <label className="block text-sm text-gray-600 mb-1">예금주</label>
                <input name="예금주" value={form.예금주} onChange={handleChange} className="w-full border rounded px-3 py-2 text-sm" />
              </div>
              <div className="flex items-center gap-2">
                <input id="create-useYn" type="checkbox" name="사용여부" checked={!!form.사용여부} onChange={handleChange} className="h-4 w-4" />
                <label htmlFor="create-useYn" className="text-sm text-gray-700">사용여부</label>
              </div>
            </div>
            <div className="px-5 py-3 border-t flex justify-end gap-2">
              <button type="button" className="px-4 py-2 text-sm rounded border border-gray-300 hover:bg-gray-50" onClick={closeCreate}>취소</button>
              <button type="button" className="px-4 py-2 text-sm rounded bg-primary-600 text-white hover:bg-primary-700" onClick={async () => {
                try {
                  const { companyNo, userNo } = getUserInfo() || {};
                  const payload = {
                    Table1: [
                      { 컬럼명: '@공급업체번호', 값: String(companyNo ?? '') },
                      { 컬럼명: '@등록자', 값: String(userNo ?? '') },
                      { 컬럼명: '@업체번호', 값: 'NULL' },
                      { 컬럼명: '@등록기준', 값: '0' },
                      { 컬럼명: '@신규업체명', 값: form.거래처명 ?? '' },
                      { 컬럼명: '@아이디', 값: '' },
                      { 컬럼명: '@이메일', 값: form.대표이메일 ?? '' },
                      { 컬럼명: '@대표자', 값: form.대표자 ?? '' },
                      { 컬럼명: '@담당자', 값: form.담당자 ?? '' },
                      { 컬럼명: '@기본주소', 값: form.기본주소 ?? '' },
                      { 컬럼명: '@상세주소', 값: form.상세주소 ?? '' },
                      { 컬럼명: '@우편번호', 값: form.우편번호 ?? '' },
                      { 컬럼명: '@국가번호', 값: form.국가번호 ?? '' },
                      { 컬럼명: '@대표전화', 값: form.대표전화 ?? '' },
                      { 컬럼명: '@이메일계정모름', 값: !(form.대표이메일 && form.대표이메일.trim()) },
                      { 컬럼명: '@은행코드', 값: form.은행코드 ?? '' },
                      { 컬럼명: '@계좌번호', 값: form.계좌번호 ?? '' },
                      { 컬럼명: '@예금주', 값: form.예금주 ?? '' },
                      { 컬럼명: '@은행명', 값: form.은행 ?? '' },
                    ],
                  };
                  const url = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.CW_T_%EA%B3%B5%EA%B8%89%EA%B1%B0%EB%9E%98%EC%B2%98%EC%B6%94%EA%B0%80_01';
                  const res = await fetch(url, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
                    body: JSON.stringify(payload),
                  });
                  if (!res.ok) {
                    window.alert('저장에 실패했습니다.');
                    return;
                  }
                  const saveData = await res.json();
                  const saved = Array.isArray(saveData?.table) && saveData.table.length > 0;
                  if (saved) {
                    const statusText = saveData.table[0]?.상태;
                    window.alert(statusText ? `저장되었습니다. (${statusText})` : '저장되었습니다.');
                  } else {
                    window.alert('저장에 실패했습니다.');
                  }
                  // Reload list
                  const reloadUrl = 'https://trpliveapi1.tripbox.co.kr/ERP/GetDataSet?procedureName=DBO.CW_S_%EA%B3%B5%EA%B8%89%EA%B1%B0%EB%9E%98%EC%B2%98';
                  const reloadPayload = {
                    Table1: [
                      { 컬럼명: '@업체번호', 값: String(companyNo ?? '') },
                      { 컬럼명: '@사용여부1', 값: true },
                      { 컬럼명: '@사용여부2', 값: true },
                    ],
                  };
                  const r2 = await fetch(reloadUrl, {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json', ...getAuthHeader() },
                    body: JSON.stringify(reloadPayload),
                  });
                  if (r2.ok) {
                    const data = await r2.json();
                    setRows(Array.isArray(data?.table) ? data.table : []);
                  }
                  setIsCreateOpen(false);
                } catch (e) {
                  window.alert('저장에 실패했습니다.');
                }
              }}>저장</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PartnerManagement;
